"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyReactFlow = void 0;
var react_1 = __importStar(require("react"));
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var Text_1 = require("office-ui-fabric-react/lib/Text");
var ReactFlowBase_1 = require("../ReactFlow/ReactFlowBase");
var strategy_transform_1 = require("./utils/strategy-transform");
var GroupNode_1 = require("./nodes/GroupNode");
var ElementNode_1 = require("./nodes/ElementNode");
var CustomEdge_1 = require("./edges/CustomEdge");
var LabelEdge_1 = require("./edges/LabelEdge");
require("./styles/strategy-react-flow.scss");
// Company orange color for hover
var HOVER_COLOR = "#FF5800";
// Register custom node types
var nodeTypes = {
    group: GroupNode_1.GroupNode,
    element: ElementNode_1.ElementNode,
};
// Register custom edge types
var edgeTypes = {
    custom: CustomEdge_1.CustomEdge,
    labelEdge: LabelEdge_1.LabelEdge,
};
/**
 * StrategyReactFlow - Visualization component for strategy structure
 * Displays strategy columns as groups with elements as nodes and connections as edges
 */
exports.StrategyReactFlow = function (_a) {
    var columns = _a.columns, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, _c = _a.className, className = _c === void 0 ? "" : _c, strategyKey = _a.strategyKey, _d = _a.fitViewTrigger, fitViewTrigger = _d === void 0 ? null : _d;
    var _e = react_1.useState(null), hoveredNodeId = _e[0], setHoveredNodeId = _e[1];
    var handleNodeHover = react_1.useCallback(function (nodeId) {
        setHoveredNodeId(nodeId);
    }, []);
    var baseElements = react_1.useMemo(function () {
        return strategy_transform_1.transformStrategyToElements(columns);
    }, [columns]);
    var highlightedData = react_1.useMemo(function () {
        if (!hoveredNodeId)
            return {
                edgeIds: new Set(),
                nodeIds: new Set(),
            };
        var edgeSet = new Set();
        var nodeSet = new Set();
        baseElements.forEach(function (element) {
            if (element.source || element.target) {
                var edge = element;
                if (edge.source === hoveredNodeId || edge.target === hoveredNodeId) {
                    edgeSet.add(edge.id);
                    if (edge.source === hoveredNodeId) {
                        nodeSet.add(edge.target);
                    }
                    if (edge.target === hoveredNodeId) {
                        nodeSet.add(edge.source);
                    }
                }
            }
        });
        return {
            edgeIds: edgeSet,
            nodeIds: nodeSet,
        };
    }, [baseElements, hoveredNodeId]);
    var elements = react_1.useMemo(function () {
        var updatedElements = baseElements.map(function (element) {
            var _a, _b, _c, _d, _e, _f;
            if (element.type === "element") {
                var isConnected = highlightedData.nodeIds.has(element.id);
                return __assign(__assign({}, element), { data: __assign(__assign({}, element.data), { onNodeHover: handleNodeHover, isHovered: hoveredNodeId === element.id, isConnected: isConnected }) });
            }
            if (element.source || element.target) {
                var edge = element;
                var isLabelEdge = edge.type === "labelEdge";
                var edgeId = isLabelEdge
                    ? ((_a = edge.data) === null || _a === void 0 ? void 0 : _a.originalEdgeId) || edge.id
                    : edge.id;
                var isHighlighted = highlightedData.edgeIds.has(edgeId) ||
                    highlightedData.edgeIds.has(edge.id);
                var shouldShowLabel = hoveredNodeId && isHighlighted ? true : false;
                var edgeZIndex = isLabelEdge
                    ? isHighlighted
                        ? 1000
                        : shouldShowLabel
                            ? 200
                            : 1
                    : isHighlighted
                        ? 1000
                        : shouldShowLabel
                            ? 100
                            : 1;
                if (isHighlighted && ((_b = edge.style) === null || _b === void 0 ? void 0 : _b.stroke) !== HOVER_COLOR) {
                    return __assign(__assign({}, edge), { data: __assign(__assign({}, edge.data), { hideLabel: !shouldShowLabel }), zIndex: edgeZIndex, style: isLabelEdge
                            ? edge.style
                            : __assign(__assign({}, edge.style), { stroke: HOVER_COLOR }) });
                }
                else if (!isHighlighted && ((_c = edge.style) === null || _c === void 0 ? void 0 : _c.stroke) === HOVER_COLOR) {
                    return __assign(__assign({}, edge), { data: __assign(__assign({}, edge.data), { hideLabel: !shouldShowLabel }), zIndex: edgeZIndex, style: isLabelEdge
                            ? edge.style
                            : __assign(__assign({}, edge.style), { stroke: ((_d = edge.data) === null || _d === void 0 ? void 0 : _d.defaultColor) || ((_e = edge.style) === null || _e === void 0 ? void 0 : _e.stroke) }) });
                }
                else if (((_f = edge.data) === null || _f === void 0 ? void 0 : _f.hideLabel) !== !shouldShowLabel ||
                    edge.zIndex !== edgeZIndex) {
                    return __assign(__assign({}, edge), { data: __assign(__assign({}, edge.data), { hideLabel: !shouldShowLabel }), zIndex: edgeZIndex });
                }
                return element;
            }
            return element;
        });
        return updatedElements.sort(function (a, b) {
            var isANode = !("source" in a);
            var isBNode = !("source" in b);
            if (isANode && !isBNode)
                return -1;
            if (!isANode && isBNode)
                return 1;
            if (!isANode && !isBNode) {
                var aIsLabel = a.type === "labelEdge";
                var bIsLabel = b.type === "labelEdge";
                if (!aIsLabel && bIsLabel)
                    return -1;
                if (aIsLabel && !bIsLabel)
                    return 1;
                var aZIndex = a.zIndex || 0;
                var bZIndex = b.zIndex || 0;
                return aZIndex - bZIndex;
            }
            return 0;
        });
    }, [baseElements, hoveredNodeId, handleNodeHover, highlightedData]);
    var hasColumns = columns && columns.length > 0;
    if (!hasColumns && !isLoading) {
        return (react_1.default.createElement("div", { className: "react-flow-base-wrapper strategy-react-flow-placeholder " + className },
            react_1.default.createElement("div", { className: "placeholder-content" },
                react_1.default.createElement(Icon_1.Icon, { iconName: "FlowChart", className: "placeholder-icon" }),
                react_1.default.createElement(Text_1.Text, { variant: "large", className: "placeholder-title" }, "Strategy Graph Visualization"),
                react_1.default.createElement(Text_1.Text, { variant: "medium", className: "placeholder-text" }, "Add strategy levels to see the visualization. The graph will display your strategy structure with levels as groups, elements as nodes, and connections as edges."))));
    }
    return (react_1.default.createElement("div", { key: strategyKey },
        react_1.default.createElement(ReactFlowBase_1.ReactFlowBase, { elements: elements, nodeTypes: nodeTypes, edgeTypes: edgeTypes, readOnly: true, showControls: true, showMinimap: false, isLoading: isLoading, fitViewOnMount: true, autoFitOnChange: false, fitViewTrigger: fitViewTrigger })));
};
